import React from "react";
import "./OpcenterPage.css";
import OpcenterOverview from "./OpcenterOverview";
import BannerImage from "../../../assets/other_image/sharePoint.jpg";
import Letsgetintouch from "../../PLMImplementation/BusinessProcessAndChangeManagement/Letsgetintouch";
import Banner from "../SolutionBanner/Banner";
import FloatingContactUs from "../../floting_contact/FloatingContactUs";

const OpcenterPage = () => {
  return (
    <section className="Opcenter-process">
      {/* Banner Section */}
      <Banner
        image={BannerImage} // Pass the image for this page
        heading="Opcenter Solutions" // Pass the heading text for this page
      />
      <FloatingContactUs />

      {/* Opcenter Overview Section */}
      <OpcenterOverview />

      {/* Benefits Section */}
      <section style={{ background: "#f5f7fa" }}>
        <div className="benefits container">
          <h4 className="Opcenter-page-heading">Unlock the Power :</h4>
          <h5 className="Opcenter-subheading">
            Discover the Transformative Benefits of Opcenter with NexTech!
          </h5>
          <ul className="custom-bullets">
            <li>Real-time insights and decision-making support to help make informed decisions quickly.</li>
            <li>Streamlined workflows and increased efficiency by reducing bottlenecks and improving task management.</li>
            <li>Quality compliance and defect reduction, ensuring adherence to quality standards while minimizing defects.</li>
            <li>Full traceability for regulated industries, tracking every part of the production process for compliance with strict regulations.</li>
            <li>Scalability for different enterprise sizes, with Opcenter adaptable to both small enterprises and large global corporations.</li>
          </ul>
        </div>
      </section>

      {/* Why Opcenter Section */}
      <section>
        <div className="solutions container">
          <h4 className="Opcenter-page-heading">Why Opcenter?</h4>
          <ul className="custom-bullets">
            <li>A digital twin that links design and production, bridging the gap to improve production accuracy.</li>
            <li>Quick innovation and problem-solving through closed-loop data, allowing faster responses to changes and challenges by utilizing data from all stages of production.</li>
          </ul>
        </div>
      </section>

      {/* Opcenter APS Section */}
      <section style={{ background: "#f5f7fa" }}>
        <div className="solutions container">
          <h4 className="Opcenter-page-heading">Opcenter APS (Advanced Planning and Scheduling)</h4>
          <p className="plmimplementationparagraph">
          Opcenter APS integrates Opcenter Planning (PL) and Opcenter Scheduling (SC), providing manufacturers with advanced tools for optimizing planning and scheduling in their production environments.
          </p>
          <h5 className="Opcenter-subheading">Key Updates</h5>
          <ul className="custom-bullets">
            <li>Unattended scheduling with new automation tools, allowing schedule management without direct user interaction and supporting batch files and command prompts for seamless operations.</li>
            <li>Known issues related to setup time conflicts and backward scheduling, with a focus on ensuring correct date-time formats in databases.</li>
          </ul>
          <h5 className="Opcenter-subheading">Opcenter APS Features</h5>
          <ul className="custom-bullets">
            <li>Opcenter Scheduling editions including Express, Standard, Professional, and Ultimate, with progressively advanced features like multi-pass scheduling and event script processing.</li>
            <li>Opcenter Planning (PL) available only in the Ultimate edition, supporting long-term planning with capacity modes to manage production based on demand and resource constraints.</li>
          </ul>
        </div>
      </section>

      {/* Opcenter MES Section */}
      <section>
        <div className="solutions container">
          <h4 className="Opcenter-page-heading">Opcenter MES (Manufacturing Execution System)</h4>
          <p className="plmimplementationparagraph">
          Opcenter MES helps optimize manufacturing processes in real time, providing control over quality,
          <br/> compliance, and performance across production lines.
          </p>
          <h5 className="Opcenter-subheading">Key Features</h5>
          <ul className="custom-bullets">
            <li>Real-time production monitoring to continuously track performance and provide analytics to improve efficiency.</li>
            <li>Work order management to automate tasks, improve work order handling, and reduce operational delays.</li>
            <li>Resource and inventory management to minimize waste and maximize resource usage for better overall efficiency.</li>
            <li>Quality control with built-in traceability, ensuring compliance with industry regulations and providing transparency for quality management.</li>
          </ul>
          <h5 className="Opcenter-subheading">Benefits</h5>
          <ul className="custom-bullets">
            <li>Improved operational efficiency through reduced downtime and better resource utilization.</li>
            <li>Enhanced product quality by ensuring adherence to industry standards and improving consistency.</li>
            <li>Compliance with industry regulations, maintaining high standards across all production processes.</li>
          </ul>
        </div>
      </section>

      {/* Opcenter Quality Management Section */}
      <section style={{ background: "#f5f7fa" }}>
        <div className="solutions container">
          <h4 className="Opcenter-page-heading">Opcenter Quality Management (QM)</h4>
          <p className="plmimplementationparagraph">
          Opcenter Quality Management (QM) is a digital tool designed to manage quality processes in manufacturing, ensuring products meet required standards and reducing defects during production.
          </p>
          <h5 className="Opcenter-subheading">Key Features</h5>
          <ul className="custom-bullets">
            <li>Real-time quality monitoring to track quality metrics throughout the production process.</li>
            <li>Document and data management to support compliance with industry standards by managing documents and data efficiently.</li>
            <li>Performance analytics for continuous improvement, helping manufacturers improve production quality and reduce waste.</li>
          </ul>
          <h5 className="Opcenter-subheading">Benefits</h5>
          <ul className="custom-bullets">
            <li>Improved product quality by ensuring that products meet high standards and regulatory requirements.</li>
            <li>Reduced defects and waste, improving overall efficiency and reducing costs.</li>
          </ul>
        </div>
      </section>

      {/* Why Choose NexTech for Opcenter Section */}
      <section>
        <div className="why-nextech container">
          <h4 className="Opcenter-page-heading">Why Choose NexTech for Opcenter</h4>
          <p className="plmimplementationparagraph">
          At NexTech, we specialize in helping businesses leverage the full potential of Siemens Opcenter. With our expert team and deep knowledge of manufacturing operations, we ensure that Opcenter is implemented in a way that aligns perfectly with your production goals. Here’s why you should choose NexTech for Opcenter:
          </p>
          <ul className="custom-bullets">
            <li>We offer tailored solutions by working with you to customize Opcenter according to your specific operational needs, ensuring maximum impact.</li>
            <li>Our expert implementation and support team is dedicated to ensuring a smooth and successful integration of Opcenter.</li>
            <li>We focus on continuous improvement, helping you optimize your manufacturing processes and drive enhanced operational efficiency.</li>
            <li>Our solutions are scalable for every enterprise size, ensuring Opcenter is adapted to suit your needs whether you’re a small business or a global enterprise.</li>
          </ul>
        </div>
      </section>

      {/* LetsGetInTouch Section */}
      <Letsgetintouch />
    </section>
  );
};

export default OpcenterPage;
